/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Modal_TitleInputs */

const en_cna_modal_title = /** @type {(inputs: Cna_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer not available`)
};

const ja_cna_modal_title = /** @type {(inputs: Cna_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客に連絡が取れない`)
};

const fr_cna_modal_title = /** @type {(inputs: Cna_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client injoignable`)
};

const de_cna_modal_title = /** @type {(inputs: Cna_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde nicht erreichbar`)
};

/**
* | output |
* | --- |
* | "Customer not available" |
*
* @param {Cna_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_modal_title = /** @type {((inputs?: Cna_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_modal_title(inputs)
	if (locale === "ja") return ja_cna_modal_title(inputs)
	if (locale === "fr") return fr_cna_modal_title(inputs)
	return de_cna_modal_title(inputs)
});